<template>
  <div class="w-100">
    {{ invoiceType() }} CREATED <b>{{ invoiceTotal() }}</b>

    <span v-if="$lodash.get(activity, 'detail.invoice.creator_name')">
      for {{ $lodash.get(activity, "detail.invoice.creator_name") }}
    </span>

    <span class="mx-1">
      <invoice-object
        :entity-id="invoiceId()"
        :invoice="$lodash.get(activity, 'detail.invoice')"
        :open-new="true"
      />
    </span>

    <pdf-object :href="invoicePdf()" />
  </div>
</template>

<script type="text/babel">
import BaseComponent from "./BaseComponent.vue";

export default {
  extends: BaseComponent,
};
</script>
